import React, { useEffect } from 'react';

export const GlobalErrorLogger: React.FC = () => {
  useEffect(() => {
    const handleError = (event: ErrorEvent) => {
      if (!event || !event.message) return;
      // Suppress cross-origin or script error noise from iframe parent container
      if (
        event.message.includes('Script error') ||
        event.message.includes('ResizeObserver') ||
        event.message.includes('aistudio.google.com')
      ) {
        return;
      }
      console.warn('StabilityLogger captured error:', event.message);
    };

    const handleRejection = (event: PromiseRejectionEvent) => {
      const msg = event?.reason?.message || String(event?.reason || '');
      // Suppress benign network failures or auth bridge redirects
      if (
        !msg ||
        msg.includes('Failed to fetch') ||
        msg.includes('aistudio.google.com') ||
        msg.includes('network error')
      ) {
        return;
      }
      console.warn('StabilityLogger captured unhandled rejection:', msg);
    };

    window.addEventListener('error', handleError);
    window.addEventListener('unhandledrejection', handleRejection);

    return () => {
      window.removeEventListener('error', handleError);
      window.removeEventListener('unhandledrejection', handleRejection);
    };
  }, []);

  return null;
};


